import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { pingUrl: String }
  static targets = ["status"]

  connect() {
    this.ping()
    this.timer = setInterval(() => this.ping(), 15000)
    this.observeStatus()
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.statusObserver) {
      this.statusObserver.disconnect()
      this.statusObserver = null
    }
  }

  ping() {
    if (!this.hasPingUrlValue) return

    fetch(this.pingUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
  }

  observeStatus() {
    if (!this.hasStatusTarget) return
    this.statusObserver = new MutationObserver(() => this.applyStatus())
    this.statusObserver.observe(this.statusTarget, { attributes: true, attributeFilter: ["data-session-status"] })
    this.applyStatus()
  }

  applyStatus() {
    if (!this.hasStatusTarget) return
    const status = this.statusTarget.dataset.sessionStatus
    const locked = status === "completed" || status === "cancelled"
    this.toggleLockableSections(locked)
    this.toggleLockableFields(locked)
  }

  toggleLockableSections(locked) {
    const activeSections = this.element.querySelectorAll("[data-session-active-section]")
    const lockedSections = this.element.querySelectorAll("[data-session-locked-section]")
    activeSections.forEach(section => section.classList.toggle("hidden", locked))
    lockedSections.forEach(section => section.classList.toggle("hidden", !locked))
  }

  toggleLockableFields(locked) {
    const lockableForms = this.element.querySelectorAll("[data-session-lockable]")
    lockableForms.forEach(form => {
      const fields = form.querySelectorAll("input, textarea, select, button")
      fields.forEach(field => {
        field.disabled = locked
        field.classList.toggle("opacity-60", locked)
      })
    })
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute("content") : ""
  }
}
